import './index.scss';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { convertToByteUnitLabel, formatDate } from '../../../js/utils';
import LoaderWithText from '../LoaderWithText';
import OperationFailureMessage from '../OperationFailureMessage';
import { deleteClone } from '../../../js/actions/manageModeActionCreators';
import { cloneStatuses } from '../../../js/statuses';
import { operationTypeToPresentParticiple, operationTypeToNoun } from '../../../js/operationTypes';
import _ from 'underscore';
import DeleteIcon from '../../../icons/clone-icons_delete.svg';
import Popup from '../Popup';

/*
 * Scalable component: Surround with <div className="clone-box pure-u-1-4"> specifying the appropriate size
 */
const CloneCard = React.createClass({
  propTypes: {
    clone: PropTypes.object.isRequired,
    deleteClone: PropTypes.func.isRequired,
    getSqlServerInstance: PropTypes.func.isRequired,
    operation: PropTypes.object
  },
  getInitialState: function () {
    return {
      showDeleteConfirmation: false
    };
  },
  onInitialDeleteClick: function (e) { this.setState({ showDeleteConfirmation: true }); e.preventDefault(); },
  onCancelDeletion: function (e) { this.setState({ showDeleteConfirmation: false }); e.preventDefault(); },
  onConfirmDeletion: function (e) {
    this.setState({ showDeleteConfirmation: false });
    this.props.deleteClone(this.props.clone.id);
    e.preventDefault();
  },
  renderInProgressClone: function (clone, qualifiedInstance, operation) {
    return (
      <div className="clone">
        <h5 className="cloneName">{clone.name}</h5>
        <ul className="pure-menu-list">
          <li className="cloneLocation pure-menu-item">{qualifiedInstance}</li>
          <li className="cloneSize pure-menu-item"><LoaderWithText loadingText={operationTypeToPresentParticiple(operation.type)} /></li>
        </ul>
      </div>
    );
  },
  renderFaultedClone: function (clone, qualifiedInstance, operation) {
    return (
      <div className="clone">
        <Popup content="Delete clone">
            <img onClick={this.onInitialDeleteClick} src={DeleteIcon} className="deleteIcon"></img>
        </Popup>
        <h5 className="cloneName">{clone.name}</h5>
        <ul className="pure-menu-list">
          <li className="cloneLocation pure-menu-item">{qualifiedInstance}</li>
        </ul>
        <OperationFailureMessage operation={operation}/>
      </div>
    );
  },
  renderDeleteConfirmationClone: function (clone) {
    return (
      <div className="clone">
        <p className="cloneMessage">Are you sure you want to delete this clone?</p>
        <Link to="#" onClick={this.onConfirmDeletion}>
          <button className="button--ghost small red">Yes, Delete</button>
        </Link>
        <Link to="#" onClick={this.onCancelDeletion}>
          <button className="button--flat-secondary">No, Cancel</button>
        </Link>
      </div>
    );
  },
  renderCloneDefault: function (clone, qualifiedInstance) {
    return (<div className="clone">
      <Popup content="Delete clone">
          <img onClick={this.onInitialDeleteClick} src={DeleteIcon} className="deleteIcon delete-icon-tour"></img>
      </Popup>
      <h5 className="cloneName">{clone.name}</h5>
      <ul className="pure-menu-list">
        <li className="cloneLocation pure-menu-item">{qualifiedInstance}</li>
        <li className="cloneSize pure-menu-item">{convertToByteUnitLabel(clone.status.sizeInBytes)}</li>
        <li className="createdDetails pure-menu-item">Created by {clone.createdBy}</li>
        <li className="createdDetails pure-menu-item">{clone.createdOnUtc && `${formatDate(clone.createdOnUtc)}`}</li>
      </ul>
    </div>);
  },
  renderCloneDetails: function(clone, operation, qualifiedInstance) {
    if (operation && operation.isInProgress()) { return this.renderInProgressClone(clone, qualifiedInstance, operation); }
    if (this.state.showDeleteConfirmation) { return this.renderDeleteConfirmationClone(clone); }
    if (operation && operation.isFaulted()) { return this.renderFaultedClone(clone, qualifiedInstance, operation); }
    return this.renderCloneDefault(clone, qualifiedInstance);
  },
  render: function () {
    const { clone, getSqlServerInstance, operation } = this.props;

    if (!clone) { return null; }
    const location = getSqlServerInstance(clone.locationId);
    const qualifiedInstance = location.server + '\\' + location.instance;

    return this.renderCloneDetails(clone, operation, qualifiedInstance);
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
      getSqlServerInstance: locationId => state.sqlServerInstances.value.get(locationId),
      operation: ownProps.clone.latestOperationId != null ? state.operations.value.get(ownProps.clone.latestOperationId) : null
    };
  };

const mapDispatchToProps = (dispatch) => {
  return {
    deleteClone: (cloneId) => {
      dispatch(deleteClone(cloneId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloneCard);



// WEBPACK FOOTER //
// ./src/components/common/CloneCard/index.jsx